/**
 * Component: Help Trigger
 * ------------------------------------------------------------------------------
 * Used on the product page to open help form.
 *
 * @namespace helpTrigger
 */
import log from 'salvo-lite/log'

class HelpTrigger {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._helpButtonLink()
    }

    _helpButtonLink () {
        const mainWrapper = document.querySelector('[data-data-layer]')
        if (!mainWrapper) {
            throw new Error('Cannot find checkout step container')
        }

        // Init mutation observer
        if (window.MutationObserver) {
            const observer = new MutationObserver(() => {
                const helpButton = document.querySelectorAll('#help-trigger')

                if (helpButton) {
                    helpButton.forEach((e) => {
                        e.addEventListener('click', () => {
                            frames['launcher'].contentWindow.document.querySelector('[data-testid="launcher"]').click()
                        })
                    })
                    observer.disconnect()
                }
            })
            observer.observe(mainWrapper, {
                childList: true,
                subtree: true
            })
        }
    }
}

export default HelpTrigger



// WEBPACK FOOTER //
// ./src/resources/scripts/components/HelpTrigger.js